import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext, getClonedData } from 'commons-ui';

import { LAUNCH_WIDGET_FORM_FIELD_KEYS } from '../utils/formConfig';
import { ILaunchWidgetSubmitData, dehydrateFormData, hydrateLaunchWidgetFormData } from '../../../utils/formDataParser';
import useService from '../../../utils/useService';
import { INoticeBoard } from '../../../interfaces';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	const { requestCreateNotice } = useService();

	const cloneNotice = (clonedData: { noticeData: INoticeBoard }) => {
		setShowLoader(true);
		const { noticeData } = clonedData;
		requestCreateNotice(app.appName, { ...noticeData }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the notice', { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Notice created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ILaunchWidgetSubmitData) => {
		cloneNotice(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateLaunchWidgetFormData(getClonedData(data, LAUNCH_WIDGET_FORM_FIELD_KEYS)),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
